import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ak{align-items:stretch;}.ssr-plugin'
import '.al{box-shadow:0px 0px 15px 0px rgba(0, 0, 0, 0.15);}.ssr-plugin'
import '.am{border-radius:1.25rem;}.ssr-plugin'
import '.ac{background-color:var(--shades-white);}.ssr-plugin'
import '.ar{overflow-y:auto;}.ssr-plugin'
import '.as{height:98dvh;}.ssr-plugin'
import '.at{width:98vw;}.ssr-plugin'
import '.au{overflow-y:hidden;}.ssr-plugin'
import '.aa{height:min(50rem, 90vh);}.ssr-plugin'
import { styled } from 'inlines'
import { Authentication } from '../authentication/Authentication'
import { ModalWrapper } from './ModalWrapper'
import { AuthTab } from '../authentication/authTabs'
import useMediaQuery from '@app/util/useMediaQuery'

export type AuthModalProps = {
  isOpen: boolean
  tab: AuthTab
  onClose: (setUtm?: boolean) => void
  verificationTab?: AuthTab | null
}

export const AuthModal = ({
  isOpen,
  tab,
  onClose,
  verificationTab,
}: AuthModalProps) => {
  const isMobile = useMediaQuery()

  if (!isOpen) {
    return null
  }

  if (isMobile) {
    return (
      <ModalWrapper>
        <div className="a b ak al am ac ar as at"
        >
          <Authentication
            tab={tab}
            onClose={onClose}
            verificationTab={verificationTab}
          />
        </div>
      </ModalWrapper>
    )
  }

  return (
    <ModalWrapper>
      <div className="a b ak al am ac au aa"
        style={{
          maxWidth: isMobile ? '90vw' : 'var(--max-width-modal)',}}
      >
        <Authentication
          tab={tab}
          onClose={onClose}
          verificationTab={verificationTab}
        />
      </div>
    </ModalWrapper>
  )
}
